/* eslint-disable react/no-danger */
import React from "react";
import { Avatar } from "@mui/material";
import moment from 'moment';
import statusLabel from "../../../utils/statusLabel";
import { i18n } from "../../../translate/i18n";

const styles = {
  timelineItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  avatar: {
    width: 50,
    height: 50,
    fontSize: 13
  },
  timelineItemHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: '100%',
    backgroundColor: '#f4f7fc',
    padding: '20px 10px 20px 10px',
    borderRadius: 8,
    marginBottom: 10,
  },
  timelineItemHeaderName: {
    width: '100%',
    marginLeft: 10,
    fontSize: '1rem',
  },
  timelineItemBody: {
    marginLeft: 60
  },
  timelineItemHeaderNameDate: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  timelineItemDate: {
    color: "#888c91",
    fontSize: '0.8rem',
  },
  timelineItemAuthor: {
    // display: 'flex',

  },
  author: {
    fontWeight: 'bold',
    marginRight: 5,
  }
}

const printColorfulStatus = (status) => (`<b style="color: ${statusLabel(status).color}">${statusLabel(status).title}</b>`);

const getAccountablesDifference = (initialAccountablesArr, newAccountablesArr) => {
  const initalAccsIds = initialAccountablesArr?.map((acc) => acc._id) || [];
  const newAccsIds = newAccountablesArr?.map((acc) => acc._id) || [];

  const addedAccountablesIds = newAccsIds.filter(accId => !initalAccsIds.includes(accId));
  const removedAccountablesIds = initalAccsIds.filter(accId => !newAccsIds.includes(accId));

  const addedAccountables = addedAccountablesIds.map((addedAccountableId) => newAccountablesArr.find(newAccountable => newAccountable?._id === addedAccountableId) || null);
  const removedAccountables = removedAccountablesIds.map((removedAccountableId) => initialAccountablesArr.find(initialAccountable => initialAccountable?._id === removedAccountableId) || null);

  return {
    added: addedAccountables,
    removed: removedAccountables
  };
}

const formatAccountablesNames = (accountables) => {
  if (accountables.length === 1) return accountables[0].name;
  const accountablesNames = accountables?.map((acc) => acc.name);
  return accountablesNames.slice(0, -1).join(', ') + ', ' + accountablesNames.slice(-1);
}

const timelineContent = (timeline) => {
  switch (timeline.type) {
    case 'changeDescription':
      return `${i18n.t('timelineContent.change_action')} ${timeline.changeDescription.from} ${i18n.t('timelineContent.to')} ${timeline.changeDescription?.to}`;
    case 'changeAccountable':
      return `${i18n.t('timelineContent.change_accountable')} ${timeline.changeAccountable.from ? timeline.changeAccountable.from.name : i18n.t('timelineContent.no_accountable')} ${i18n.t('timelineContent.to')} ${timeline.changeAccountable.to ? timeline.changeAccountable.to.name : i18n.t('timelineContent.no_accountable')}`;
    case 'addAccountable':
      return `${i18n.t('timelineContent.add')} ${timeline.addAccountable.to ? timeline.addAccountable.to.name : i18n.t('timelineContent.noAccountable')} ${i18n.t('timelineContent.text')}`;
    case 'changeAccountables':
      const addedOrRemovedAccountables = getAccountablesDifference(timeline.changeAccountables.from, timeline.changeAccountables.to);
      const isOneRemoved = addedOrRemovedAccountables.removed.length === 1;
      const isOneAdded = addedOrRemovedAccountables.added.length === 1;
      if (addedOrRemovedAccountables.removed.length > 0 && addedOrRemovedAccountables.added.length > 0) {
        return `${isOneRemoved ? i18n.t('timelineContent.removedAccountable'): i18n.t('timelineContent.removedAccountables')} ${formatAccountablesNames(addedOrRemovedAccountables.removed)} ${i18n.t('timelineContent.andAdded')} ${formatAccountablesNames(addedOrRemovedAccountables.added)}`;
      }
      if (addedOrRemovedAccountables.removed.length > 0) {
        return `${isOneRemoved ? i18n.t('timelineContent.removedAccountable'): i18n.t('timelineContent.removedAccountables')} ${formatAccountablesNames(addedOrRemovedAccountables.removed)}`;
      }
      if (addedOrRemovedAccountables.added.length > 0) {
        return `${isOneAdded ? i18n.t('timelineContent.addedAccountable') : i18n.t('timelineContent.addedAccountables')} ${formatAccountablesNames(addedOrRemovedAccountables.added)}`;
      }
    case 'addAccountables':
      return `${timeline.addAccountables?.to.length === 1 ? i18n.t('timelineContent.addedAccountable') : i18n.t('timelineContent.addedAccountables')} ${timeline.addAccountables?.to.length > 0 ? formatAccountablesNames(timeline.addAccountables?.to) : i18n.t('timelineContent.noAccountable')}`;
    case 'changeStatus':
      return <span dangerouslySetInnerHTML={{ __html: `${i18n.t('timelineContent.status')} ${printColorfulStatus(timeline.changeStatus.from)} ${i18n.t('timelineContent.to')} ${printColorfulStatus(timeline.changeStatus.to)}` }} />
    case 'creation':
      return `${i18n.t('timelineContent.created')}`
    case 'changeDeadline':
      return `${i18n.t('timelineContent.deadLine')} ${moment(timeline.changeDeadline.from).format('DD/MM/YYYY')} ${i18n.t('timelineContent.to')} ${moment(timeline.changeDeadline.to).format('DD/MM/YYYY')}`
    case `conversation`:
      return <div dangerouslySetInnerHTML={{ __html: `${timeline.conversation.message}` }} />
    default:
      return i18n.t('timelineContent.change');
  }
}

const TimelineItem = props => {
  return (
    <div>
      {props.timeline && props.timeline.map(timeline =>
        <div style={styles.timelineItem} key={timeline._id}>
          <div style={styles.timelineItemHeader}>
            <Avatar style={styles.avatar}>{' '}</Avatar>
            <div style={styles.timelineItemHeaderName}>
              <div style={styles.timelineItemAuthor}>
                <span style={styles.author}>{timeline.author.name}</span>
                <span>{timelineContent(timeline)}</span>
              </div>
              <div style={styles.timelineItemDate}>
                {moment(timeline.createdAt).format('DD/MM/YYYY, k:mm')}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimelineItem;
